import React, { useState } from 'react';
import { aplicarReset, signInWithEmailAndPassword, auth } from '../utils/auth';
import { LogoLockup, LogoChatbularisSVG } from '../components/Icons';
import ClaveInput from '../components/ClaveInput';

// Página para definir/restablecer contraseña desde el enlace del correo
// (/reset?token=...). Sirve tanto para "olvidé mi clave" como para invitaciones.
//
// Con &ir=asistente el enlace es de Chatbularis (estudio sin panel, o invitado
// a Chatbularis): se muestra con su logo y, al guardar, se entra ahí directo.
const ResetPage: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') || '';
  const chat = params.get('ir') === 'asistente';
  const destino = chat ? '/asistente' : '/';
  const [pass, setPass] = useState('');
  const [pass2, setPass2] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (pass.length < 8) { setError('La contraseña debe tener al menos 8 caracteres.'); return; }
    if (pass !== pass2) { setError('Las contraseñas no coinciden.'); return; }
    setLoading(true);
    try {
      const email = await aplicarReset(token, pass);
      // Entra solo con la contraseña que acaba de crear: pedírsela de nuevo
      // en la pantalla siguiente es un paso que no aporta nada. Si el ingreso
      // falla por lo que sea, queda el botón para hacerlo a mano.
      if (email) {
        try {
          await signInWithEmailAndPassword(auth, email, pass);
          window.location.replace(destino);
          return;
        } catch { /* sigue al botón */ }
      }
      setOk(true);
    } catch {
      setError('El enlace es inválido o venció. Solicita uno nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="panel-overlay">
      <div className="login-box">
        {chat
          ? <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}><LogoChatbularisSVG size={44} /><span style={{ fontFamily: 'Playfair Display, serif', fontSize: 22, color: '#0D1B35' }}>Chatbularis</span></div>
          : <LogoLockup height={34} />}
        <h2>{chat ? 'Crea tu contraseña' : 'Definir contraseña'}</h2>
        {!token && <div className="login-error">Falta el token del enlace.</div>}
        {ok ? (
          <>
            <p>¡Contraseña actualizada!</p>
            <a className="p-btn-primary" href={destino} style={{ display: 'inline-block', marginTop: 12, textDecoration: 'none' }}>{chat ? 'Entrar a Chatbularis →' : 'Ir a iniciar sesión →'}</a>
          </>
        ) : (
          <form onSubmit={submit} style={{ width: '100%' }}>
            <div className="p-field"><div className="p-field-label">Nueva contraseña</div>
              <ClaveInput className="p-input" value={pass} onChange={e => setPass(e.target.value)} placeholder="Mínimo 8 caracteres" disabled={loading || !token} colorOjo="#8FB0E6" /></div>
            <div className="p-field"><div className="p-field-label">Repetir contraseña</div>
              <ClaveInput className="p-input" value={pass2} onChange={e => setPass2(e.target.value)} placeholder="••••••••" disabled={loading || !token} colorOjo="#8FB0E6" /></div>
            {error && <div className="login-error">{error}</div>}
            <button className="p-btn-primary" type="submit" disabled={loading || !token} style={{ width: '100%', padding: '0.85rem' }}>
              {loading ? 'Guardando...' : 'Guardar contraseña'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPage;
